
import React from "react";
import { useTranslation } from "react-i18next";
import { reactApi, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { join } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { singleton, append, delay, toList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { ofArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";

export function PageHeader(props) {
    const patternInput = useTranslation();
    return reactElement("div", {
        className: join(" ", ["font-ubuntu", "font-bold", "text-4xl", "text-black", "mb-4"]),
        children: patternInput[0](props.Text),
    });
}

export function SectionHeader(props) {
    const patternInput = useTranslation();
    return reactElement("div", {
        className: join(" ", ["font-bold", "text-2xl", "text-black", "mb-4"]),
        children: patternInput[0](props.Text),
    });
}

export function BlockHeader(props) {
    const patternInput = useTranslation();
    return reactElement("div", {
        className: join(" ", ["font-bold", "text-sm", "text-black", "mb-4"]),
        children: patternInput[0](props.Text),
    });
}

export function BoxHeader(props) {
    const patternInput = useTranslation();
    return reactElement("div", {
        className: join(" ", ["font-bold", "text-xl", "text-black", "mb-4"]),
        children: patternInput[0](props.Text),
    });
}

export function TextValue(props) {
    return reactElement("div", {
        className: join(" ", toList(delay(() => {
            let matchValue;
            return append((matchValue = props.FontWeight, (matchValue === "semiBold") ? singleton("font-semibold") : ((matchValue === "normal") ? singleton("font-normal") : ((matchValue === "small") ? singleton("text-sm") : singleton("font-bold")))), delay(() => append(singleton("text-sm"), delay(() => append(singleton("text-black"), delay(() => singleton("whitespace-pre-wrap")))))));
        }))),
        children: props.Text,
        "data-test-id": props.TestId,
    });
}

export function SmallTextValue(props) {
    return reactElement("div", {
        className: join(" ", toList(delay(() => {
            let matchValue;
            return append((matchValue = props.FontWeight, (matchValue === "semiBold") ? singleton("font-semibold") : ((matchValue === "normal") ? singleton("font-normal") : ((matchValue === "small") ? singleton("font-light") : singleton("font-bold")))), delay(() => append(singleton("text-xs"), delay(() => append(singleton("text-black"), delay(() => singleton("whitespace-pre-wrap")))))));
        }))),
        children: props.Text,
        "data-test-id": props.TestId,
    });
}

export function LabeledValue(props) {
    let elems;
    return reactElement("div", createObj(ofArray([["className", join(" ", ["mb-3"])], (elems = [reactElement("div", {
        className: join(" ", ["font-bold", "mb-1"]),
        children: props.Label,
    }), reactElement("div", {
        className: join(" ", ["text-lg", "min-h-[28px]"]),
        children: props.Value,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function ModalTitle(props) {
    const patternInput = useTranslation();
    return reactElement("div", {
        className: join(" ", ["font-bold", "text-lg", "text-black", "flex-1", "truncate"]),
        children: patternInput[0](props.Text),
    });
}

export function InvalidTextValue(props) {
    return reactElement("div", {
        "data-test-id": props.TestId,
        className: join(" ", ["text-red", "text-sm"]),
        children: props.Text,
    });
}

